export const safeMathRandom = (): number => {
  const buf = new Uint32Array(1);
  crypto.getRandomValues(buf);

  return buf[0] / 0x100000000;
};

export const generateRandomInteger = (min = 1, max = 9, digit = 10): number => {
  const rand = min + safeMathRandom() * (max + 1 - min);

  return Math.floor(rand * 10 ** digit);
};
